<script>
import Multiselect from 'vue-multiselect';
import axios from 'axios';

export default {
    name: 'ImportQuoteSelect',
    components: { Multiselect },
    props: {
        initialOptions: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            options: [],
            selected: null,
        };
    },
    computed: {
        selectedQuoteId() {
            return this.selected ? this.selected.id : null;
        },
    },
    mounted() {
        this.options = this.initialOptions;
    },
    methods: {
        async asyncFind(query) {
            const { data } = await axios.get('/api/app-v1/quotes', {
                params: {
                    q: query,
                },
            });

            this.options = data;
        },
    },
};
</script>

<template>
    <div>
        <Multiselect
            ref="select"
            v-model="selected"
            :options="options"
            track-by="id"
            label="number_event_name"
            select-label=""
            :multiple="false"
            @search-change="asyncFind"
        >
            <template #option="props">

                <div class="option__desc d-flex align-items-center">
                    <span
                        v-if="props.option.is_template"
                        class="badge badge-info mr-3"
                    >
                        Template
                    </span>
                    <span class="option__title">{{ props.option.number_event_name }}</span>
                </div>
            </template>
        </Multiselect>
        <input
            v-model="selectedQuoteId"
            type="hidden"
            name="quote_id"
        >
    </div>
</template>

<style
    scoped
    lang="scss"
>

</style>
